import React, { useContext } from 'react';
import { Container } from '@material-ui/core';
import Header from '../components/Header';
import Loader from '../components/Loader';
import HomeContent from './HomeContent';
import ApiService from '../helpers/ApiService';
import ErrorScreen from '../components/ErrorScreen';
import { URLContext } from '../../contexts/URLContext';

const Home = () => {
  const {globalUserID, globalCampaignID, setGlobalUserID, setGlobalCampaignID, dataLoaded} = useContext(URLContext);

  const [ loading, setLoading ] = React.useState(true);
  const [ requestError, setRequestError ] = React.useState(false);
  const [ tickets, setTickets ] = React.useState([]);

  const refreshApp = () => {
    window.location.reload();
  }

  let userID = new URLSearchParams(window.location.search).get('id');
  if( userID === null && globalUserID !== null ) {
    userID = globalUserID;
    document.location.search = "id=" + userID;
  }
  else if( globalUserID === null ) {
    setGlobalUserID(userID);
  }

  let campaignID = new URLSearchParams(window.location.search).get('campaign');
  if( campaignID === null && globalCampaignID !== null ) {
    campaignID = globalCampaignID;
    document.location.search = "campaign=" + campaignID;
  }
  else if ( globalCampaignID === null ) {
    setGlobalCampaignID(campaignID);
  }

  React.useEffect(() => {
    setLoading(false);

    //CALL API -> Return tickets
    ApiService.get("/api/v1/ticket/get", { uuid: userID, campaign: campaignID }).then(( {data} ) => {
      setTickets(data.tickets);
      setLoading(true);
    }).catch((error) => {
      setLoading(true);
      setRequestError(true);
      console.log(error);
    });
  }, [userID, campaignID]);

  return(
    <Container style={{ padding: 0, maxWidth: 550 }}>
      {loading && dataLoaded !== undefined ? ( 
        <>
          <Header />
          { !requestError ? (
            <HomeContent
              tickets={tickets}
              userID={userID}
            />
          ) : (
            <ErrorScreen
              target={refreshApp}
              button="Tentar novamente"
            >
              {`Ooops...<br/>
              Houve um erro ao carregar suas informações`}
            </ErrorScreen>
          )}
        </>
      ):(
        <Loader message="Carregando seus dados" />
      )}
    </Container>
  );
};

export default Home;